import type { FaireProductEntity } from "../../entity_types/product";

export const p_us4pgy2uur: FaireProductEntity = {
  token: "p_us4pgy2uur",
  type: "product",
  name: "Open front blazer",
  brandToken: "b_erg8vzmjsk",
  brandName: "Miss Sparkling",
  imageUrl:
    "https://cdn.faire.com/fastly/985785e2b2f20096b4984f2f57f5905a44fb2473f99fce4bb319bc0bf869edc5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dce0574d04274bb94dce952e565e7c559864fa9e97a785d78423f2520f913102.jpeg",
    "https://cdn.faire.com/fastly/8c91031328748e0e31ab9cc4b1c3a9faa43d427d9916d31d0cce4c7c46509dc4.jpeg",
    "https://cdn.faire.com/fastly/a5668da854cdb65c5d6617c791a272acc5a34f019f4678c3c32a610dfc079d84.jpeg",
    "https://cdn.faire.com/fastly/2c256e181f37ba08586a4fd2d009d22994538728940b2e068805e75c1929d574.jpeg",
    "https://cdn.faire.com/fastly/a86828136a1f2d276546dcd96e9270365ac2bd3ee155c36707956c81d30873ca.jpeg",
  ],
  priceDollars: 25.9,
  description:
    "Open front blazer\nLong sleeves\nFaux pockets at sides\n\n100% polyester",
  tags: [],
  msrpDollars: 51.8,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:42.831Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
